import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApplianceI, selectedApplianceI } from '../types/appliances';

const getInitialApplianceState = (): selectedApplianceI => ({
    appliance: {
        id: 0,
        label: '',
        icon: '',
        type: '',
        applianceType: '',
        state: '',
        actuator: 0,
        connectedTo: []
    }
});

const initialState: selectedApplianceI = getInitialApplianceState();

const appliancesSlice = createSlice({
    name: 'appliances',
    initialState,
    reducers: {
       setSelectedAppliance: (state, action: PayloadAction<ApplianceI>) => {
            state.appliance = action.payload;
        }
    }
});

export const {
    setSelectedAppliance
} = appliancesSlice.actions;
export default appliancesSlice.reducer;